import { useDispatch } from 'react-redux';

import { TDispatch } from 'shared/mf-my-home/types/redux';

export const useAppDispatch: () => TDispatch = useDispatch;
